import { ReactNode } from 'react';

import { ColumnContainer } from './style';

export interface ColumnProps {
	$gap?: number;
	$reverse?: boolean;
	$hcenter?: boolean;
	$vcenter?: boolean;
	$spaceBetween?: boolean;
	$fillHeight?: boolean;
	children: ReactNode;
	className?: string;
}

export function Column({
	$gap = 0,
	$reverse = false,
	$hcenter = false,
	$vcenter = false,
	$spaceBetween = false,
	$fillHeight = false,
	children,
	className,
}: ColumnProps) {
	return (
		<ColumnContainer
			className={className}
			$gap={$gap}
			$reverse={$reverse}
			$hcenter={$hcenter}
			$vcenter={$vcenter}
			$spaceBetween={$spaceBetween}
			$fillHeight={$fillHeight}
		>
			{children}
		</ColumnContainer>
	);
}
